import { network } from 'services/network';

import { QueryParams } from 'api/queries/getMapping.query';

export const getMapping = (params: QueryParams) => {
    delete params.contractUuid;

    return network.post('api/bo/phaseperformance/getMapping', params).then((response) => {
        return response.data;
    });
};
